import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Sort } from '@angular/material/sort';
import { Router } from '@angular/router';
import { NotificationType } from 'src/app/enum/notification-type.enum';
import { TableColumn } from 'src/app/home/table/TableColumn';
import { CommPlan } from 'src/app/models/commission/comm-plan.model';
import { CalcRunCtrl } from 'src/app/models/onlinecalc/calc-run-ctrl.model';
import { AuthGaurdService } from 'src/app/service/auth-gaurd.service';
import { CommissionService } from 'src/app/service/commission.service';
import { ExportExcelService } from 'src/app/service/export-excel.service';
import { GlobalService } from 'src/app/service/global.service';
import { NotificationService } from 'src/app/service/notification.service';
import { OnlineCalcService } from 'src/app/service/onlinecalc.service';

@Component({
  selector: 'app-user-control',
  templateUrl: './user-control.component.html',
  styleUrls: ['./user-control.component.css']
})
export class UserControlComponent implements OnInit {
  columnsData: any;
  dataForExcel = [];
  columnsExcelData: any;
  ordersTableExcelHeaderColumns: TableColumn[];
  ordersTableColumns: TableColumn[];
  filteredCalRunCtrlModel: CalcRunCtrl[] = [];
  headder: string = 'Run Commission Calc';
  actionButtons: any;
  calcRunCtrlModel = new CalcRunCtrl();
  IsmodelShow: boolean = false;
  flags: string[] = ['Y', 'N'];
  commData: CommPlan[] = [];
  salesChannels: string[] = [];
  myModelProperty: any;
  private selItems: Array<any>;
  calRunIdsData: CalcRunCtrl[] = [];
  commPlansList: CalcRunCtrl[] = [];
  empIdList: CalcRunCtrl[] = [];
  calcRunCtrlModels: CalcRunCtrl[] = [];
  labelColumn: TableColumn[];
  selectedCalRun = new CalcRunCtrl();
  exportExcelUserData: CalcRunCtrl[] = [];
  isAccessDisabled: boolean = false;

  public selctedRuns: CalcRunCtrl[] = [];
  public filterRunsData: CalcRunCtrl[] = [];
  public runsData: CalcRunCtrl[] = [];
  public isChecked: boolean = false;

  constructor(private httpService: HttpClient, private notificationService: NotificationService,
    private onlineCalcService: OnlineCalcService, private router: Router,
    private exportExcelService: ExportExcelService, private globalService: GlobalService,
    private commissionService: CommissionService, private authgurdService: AuthGaurdService) { globalService._disableBackButton(); }

  ngOnInit(): void {
    this.init();
    this.isAccessDisabled = this.globalService._permissionCheck('user-control');
    if (this.isAccessDisabled) {
      this.notificationService.notify(NotificationType.WARNING, "Edit Permission Has Disabled Please Contact To Adminstrator");
    }
  }

  init() {
    this.calcRunCtrlModels = [];
    this.initializeColumns();
    this.getAllCommPlans();
    this.getCalRunNames();
    this.initializeExcelHeaders();
  }

  public getCalRunNames(): void {
    this.onlineCalcService.getCalRunNames().subscribe(
      (response: CalcRunCtrl[]) => {
        this.filteredCalRunCtrlModel = response;
        // console.log(JSON.stringify(this.filteredCalRunCtrlModel));

         // filter active kpis
         const filterValue = this.globalService._normalizeValue('Y');
         this.filterRunsData = this.filteredCalRunCtrlModel.filter(comm => this.globalService._normalizeValue(comm.active_status).startsWith(filterValue));
         this.filterRunsData = this.filterRunsData.filter((v, i) => this.filterRunsData.findIndex(item => item.run_control_name == v.run_control_name) === i);
 
         this.runsData = this.filterRunsData;
        // console.log( this.runsData);

      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      }
    )
  }


  redirect(url: string) { }

  customSort(sortParameters: Sort) {
    console.log('=====', sortParameters);
  }

  initializeExcelHeaders(): void {
    this.httpService.get('../../../assets/json/excelHeaders.json').subscribe(
      data => {
        this.columnsExcelData = data;
        this.ordersTableExcelHeaderColumns = this.columnsExcelData.ExcelUserControlData;
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      }
    );
  }

  exportExcel() {
    this.exportExcelUserData = JSON.parse(JSON.stringify(this.runsData));
    for (let js of this.exportExcelUserData) {
      delete js.id;
      delete js.cal_run_id;
      delete js.comm_plan_id;
      delete js.locked;
      delete js.sc_emp_id;
      delete js.created_by;
      delete js.created_dt;
      delete js.updated_by;
      delete js.updated_dt;
      delete js.run_all_open_flg;
      delete js.commPlan;
      delete js.empName;
    }
    this.dataForExcel = [];
    let reportData = null;
    this.exportExcelUserData.forEach((row: any) => {
      this.dataForExcel.push(Object.values(row))
    })
    reportData = {
      title: 'User Control',
      data: this.dataForExcel,
      headers: Object.keys(this.ordersTableExcelHeaderColumns[0])
    }
    this.exportExcelService.exportExcel(reportData);
  }


  public updateStatusToActiveInactive(stat: string) {
    this.selctedRuns[0].active_status = stat;
    this.onlineCalcService.updateStatusToActiveInactive(this.selctedRuns)
      .subscribe(response => {
        this.notificationService.sendNotification(NotificationType.SUCCESS, 'Updated Successfully');
        this.getCalRunNames();
        this.selctedRuns = [];
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      })
  }

  public getInactiveRuns(): void {
    this.runsData = this.filteredCalRunCtrlModel;
  }

  public getActiveRuns(): void {
    this.runsData = this.filterRunsData;
  }

  changed(values: any) {
    this.isChecked = values.value.currentTarget.checked;

    if (values.value.currentTarget.checked == true) {
      this.getInactiveRuns();
    } else {
      this.getActiveRuns();
    }
  }

  update(user: any, values: any) {
    console.log("update called");
    if (values.value.currentTarget.checked) {
      this.selctedRuns.push(user.row);
    } else {
      this.selctedRuns.forEach((value: any, index: any) => {
        if (value.run_control_name == user.row.run_control_name) this.selctedRuns.splice(index, 1);
      });
    }
  }

  actionOnButton(action: any) {
    console.log(action.row);
    // if (!this.isAccessDisabled) {
    //   const calRun = new CalcRunCtrl();
    //   this.onlineCalcService.selectedCalRun = calRun;
    //   this.router.navigate(['/add-calcrun'], { queryParams: { page: 'save' } });
    // }
    if (action === "Add") {

      localStorage.removeItem("selectedCalRun");

      if (this.isAccessDisabled === true) {
        this.notificationService.sendNotification(NotificationType.WARNING, NotificationType.PERMISSIONS_MSG);
      } else {
        const calRun = new CalcRunCtrl();
        this.onlineCalcService.selectedCalRun = calRun;
        this.router.navigate(['/add-calcrun'], { queryParams: { page: 'save' } });
      }
    } else if (action === "Active") {
      if (this.isAccessDisabled === true) {
        this.notificationService.sendNotification(NotificationType.WARNING, NotificationType.PERMISSIONS_MSG);
      } else {
        this.updateStatusToActiveInactive('Y');
      }
    } else if (action === "Inactive") {
      if (this.isAccessDisabled === true) {
        this.notificationService.sendNotification(NotificationType.WARNING, NotificationType.PERMISSIONS_MSG);
      } else {
        this.updateStatusToActiveInactive('N');
      }
    }
  }

  rowAction(row: any) {
    console.log(row);
    if (row.value === 'View') {
      console.log(row.row.runCtrlId);
      this.selectedCalRun = row.row;
      this.onlineCalcService.selectedCalRun = this.selectedCalRun;

      localStorage.setItem("selectedCalRun",JSON.stringify(this.selectedCalRun));

      this.router.navigate(['/add-calcrun'], { queryParams: { page: 'update' } })
    }
  }

  close(kpiForm: NgForm, id: string) {
    console.log('======', kpiForm);

    if (confirm("Do you want to close the popup without saving?")) {
      this.IsmodelShow = true;
      kpiForm.reset();
      document.getElementById(id).click();
      this.init();
    }

  }

  public createRunCtrl(kpiForm: NgForm) {

    for (let calrunModl of this.calcRunCtrlModels) {
      calrunModl.saleschannel = calrunModl.saleschannel.toString();
      calrunModl.cal_run_id = calrunModl.cal_run_id.toString();
      calrunModl.sc_emp_id = calrunModl.sc_emp_id.toString();
    }
    console.log(JSON.stringify(this.calcRunCtrlModels));
    this.onlineCalcService.saveRunCtrl(this.calcRunCtrlModels)
      .subscribe(response => {
        // response = response as ErrorResponseMessage;
        console.log(' relicate resp=== ', response);
        if (response) {
          this.notificationService.sendNotification(NotificationType.SUCCESS, `Run Control Added Successfully`);
          kpiForm.reset();
        }
        else
          this.notificationService.sendNotification(NotificationType.ERROR, 'Something Went Wrong');
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      })
  }

  getAllCommPlans() {
    this.commissionService.getAllCommPlans()
      .subscribe((data: CommPlan[]) => {
        this.commData = data;
        this.getSalesChannels();
        this.getCalRunIDsBySalesChnl();

      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      });
    this.calcRunCtrlModel.created_by =localStorage.getItem('CURRENT_USER_NAME_SESSION');
    this.calcRunCtrlModel.created_dt = new Date();
    this.calcRunCtrlModels.push(this.calcRunCtrlModel);
  }

  getSalesChannels() {
    for (let comm of this.commData) {
      if (comm.sales_channel_desc) {
        this.salesChannels.push(comm.sales_channel_desc);
      }
    }
    this.salesChannels = this.salesChannels.sort((a, b) => (a < b) ? -1 : 1);
    this.salesChannels = this.salesChannels.filter((v, i) => this.salesChannels.findIndex(item => item == v) === i);
  }

  selectedComm(e: any) {
    console.log(this.myModelProperty);
    this.getCommPlans(this.calcRunCtrlModel.saleschannel);
  }

  getCalRunIDsBySalesChnl() {
    this.onlineCalcService.getCalRunIDsBySalesChnl().subscribe(
      (response: CalcRunCtrl[]) => {
        this.calRunIdsData = response;
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      }
    )
  }

  getCommPlans(salesChannels: string) {
    console.log(salesChannels);
    console.log(JSON.stringify(this.calcRunCtrlModels));
    this.onlineCalcService.getCommPlans(salesChannels).subscribe(
      (response: CalcRunCtrl[]) => {
        this.commPlansList = response;
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      }
    )
  }

  getCommPlan(commPlan: any) {
    console.log(commPlan.target.value);
    console.log(this.calcRunCtrlModel.comm_plan_id);
    console.log(this.calcRunCtrlModel.cal_run_id);
    this.getEmpIDList(this.calcRunCtrlModel.comm_plan_id,this.calcRunCtrlModel.cal_run_id);
  }

  getEmpIDList(commPlanId: number,cal_run_id:any) {
    this.onlineCalcService.getEmpIdList(commPlanId,cal_run_id).subscribe(
      (response: CalcRunCtrl[]) => {
        this.empIdList = response;
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      }
    )
  }

  addNewRow() {
    const calcRunCtrlModl = new CalcRunCtrl();
    calcRunCtrlModl.run_control_name = this.calcRunCtrlModel.run_control_name;
    calcRunCtrlModl.description = this.calcRunCtrlModel.description;
    calcRunCtrlModl.cal_run_id = this.calcRunCtrlModel.cal_run_id;
    calcRunCtrlModl.saleschannel = this.calcRunCtrlModel.saleschannel;
    this.calcRunCtrlModels.push(calcRunCtrlModl);
  }

  check(id: number): boolean {
    if (id === 0)
      return true;
    else
      return false;
  }

  runCalcForAll(event: any) {
  }

  initializeColumns(): void {
    this.httpService.get('../../../assets/json/tableColumns.json').subscribe(
      data => {
        this.columnsData = data;
        this.ordersTableColumns = this.columnsData.userControlJson;
        //console.log(this.ordersTableColumns);
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      }
    );
    this.actionButtons = [
      {
        name: 'Add',
        class: 'btn btn-primary btn-xs'
      },
      {
        name: 'Active',
        class: 'btn btn-success btn-xs'
      },
      {
        name: 'Inactive',
        class: 'btn btn-danger btn-xs'
      }
    ],
      this.labelColumn = [{
        "name": "Commission Plan",
        "dataKey": "rangeLow",
        "position": "left",
        "isSortable": true,
        "edit": true,
        "type": "number"
      },
      {
        "name": "Emp Name/ID",
        "dataKey": "range_high",
        "position": "left",
        "isSortable": true,
        "edit": false,
        "type": "number"
      }
      ]
  }

}
